import { render, staticRenderFns } from "./param-tri-urgence.html?vue&type=template&id=0f97ee8c&scoped=true&external"
import script from "./param-tri-urgence.js?vue&type=script&lang=js&external"
export * from "./param-tri-urgence.js?vue&type=script&lang=js&external"
import style0 from "./param-tri-urgence.scss?vue&type=style&index=0&id=0f97ee8c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f97ee8c",
  null
  
)

export default component.exports